module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Cooking-pot-cb13292b7f710d910411ed0a35df0960.svg";